<header class="header-section">
    <div class="bg-primary text-white facility-name"
        *ngIf="isFacilityUser() && _coreHelper.selectedUserStatus !== userStatus.Break">
        {{this.facilityName}}
    </div>
    <div [ngClass]="{ 'bg-danger': _coreHelper.selectedUserStatus === userStatus.Break && isVOBDepartment() }"
        class="text-white facility-name"
        *ngIf="_coreHelper.selectedUserStatus === userStatus.Break && isVOBDepartment()">
        You are on break
    </div>
    <div class="row align-items-center">
        <div class="col-xxl-5 col-xl-5 col-lg-6 col-md-6">
            <div class="page-title">
                <h1>{{ getPageTitle() }}</h1>
            </div>
        </div>
        <div class="col-xxl-7 col-xl-7 col-lg-6 col-md-6">
            <nav class="navbar navbar-expand justify-content-end">
                <div class="header-main-search">
                    <div *ngIf="notificationUnreadCount > 0" class="unread-messages-alert" style="display:none;">
                        <a class="nav-link" href="javascript:;" [routerLink]="['auth/messages']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
                            Unread messages
                        </a>
                    </div>
                </div>
                <div class="common-navbar">
                    <ul class="navbar-nav align-items-center">
                        <!-- Notification Bell ICON -->
                        <li class="nav-item notification-wrapper" #notificationWrapper>
                            <div kendoTooltip class="grid-tooltip">
                                <a class="nav-link" [class.bell-active]="showNotificationPanel"
                                    title="{{notificationUnreadCount}} unread / {{notificationCount}} total"
                                    (click)="toggleNotificationPanel()" href="javascript:;" aria-haspopup="true"
                                    [attr.aria-expanded]="showNotificationPanel">
                                    <span *ngIf="notificationUnreadCount > 0"
                                        class="nav-status unread-messages-alert"></span>
                                    <span class="custom-icons icon-bell m-r" style="width: 29px;"></span>
                                </a>
                            </div>

                            <!-- Notification Popover start -->
                            <div class="notification-panel" *ngIf="showNotificationPanel" role="dialog"
                                aria-label="Notifications">
                                <div class="np-header">Notifications</div>

                                <!-- Quick Actions -->
                                <div class="np-actions">
                                    <button type="button" class="np-action-card" (click)="requestVob()">
                                        <span class="np-plus">
                                            <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                                <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" fill="none" />
                                            </svg>
                                        </span>
                                        <span class="np-action-text">
                                            <span class="np-action-title">Request a VOB</span>
                                            <span class="np-action-sub">verify a policy</span>
                                        </span>
                                    </button>
                                    <button type="button" class="np-action-card" (click)="requestPrecert()">
                                        <span class="np-plus">
                                            <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                                <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" fill="none" />
                                            </svg>
                                        </span>
                                        <span class="np-action-text">
                                            <span class="np-action-title">Request Precert</span>
                                            <span class="np-action-sub">get auth</span>
                                        </span>
                                    </button>
                                </div>

                                <!-- Recent Activity -->
                                <div class="np-section-title">
                                    RECENT ACTIVITY <span class="np-count">{{ notificationCount }}</span>
                                </div>

                                <ul class="np-list" *ngIf="notifications?.length > 0; else noNotification">
                                    <li *ngFor="let notify of notifications; trackBy: trackByNotificationId"
                                        class="np-item" [class.np-unread]="notify.isReaded == 0"
                                        (click)="markNotificationAsReaded(notify)">
                                        <span class="np-file-icon">
                                            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                                                <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"
                                                    fill="none" stroke="currentColor" stroke-width="1.6"
                                                    stroke-linejoin="round" />
                                                <path d="M14 3v5h5M9 13h6M9 17h6" fill="none" stroke="currentColor"
                                                    stroke-width="1.6" stroke-linecap="round" />
                                            </svg>
                                        </span>
                                        <span class="np-title" [title]="notify.title">{{ notify.title }}</span>
                                        <span class="np-time">{{ notify.tillNow }}</span>
                                    </li>
                                </ul>

                                <ng-template #noNotification>
                                    <div class="np-empty">You do not have any notification.</div>
                                </ng-template>

                                <div class="np-footer">Requests and notifications stay here for 7 days.</div>
                            </div>
                            <!-- Notification Popover end -->
                        </li>

                        <!-- Profile ICON -->
                        <li class="nav-item profile-wrapper" #profileWrapper>
                            <a class="nav-link" href="javascript:;" role="button" aria-haspopup="true"
                                [attr.aria-expanded]="showProfilePanel" (click)="toggleProfilePanel()">
                                <span class="pp-avatar pp-avatar-btn" [title]="userName"
                                    [ngClass]="{ 'ring-success': _coreHelper.selectedUserStatus === userStatus.Available,
                                    'ring-warning': _coreHelper.selectedUserStatus === userStatus.Away,
                                    'ring-danger': _coreHelper.selectedUserStatus === userStatus.Busy || _coreHelper.selectedUserStatus === userStatus.Break }">
                                    {{ userInitials }}
                                </span>
                            </a>

                            <!-- Profile Popover start -->
                            <div class="profile-panel" *ngIf="showProfilePanel" role="dialog" aria-label="Profile">

                                <!-- User Card -->
                                <div class="pp-user">
                                    <span class="pp-avatar"
                                        [ngClass]="{ 'ring-success': _coreHelper.selectedUserStatus === userStatus.Available,
                                        'ring-warning': _coreHelper.selectedUserStatus === userStatus.Away,
                                        'ring-danger': _coreHelper.selectedUserStatus === userStatus.Busy || _coreHelper.selectedUserStatus === userStatus.Break }">
                                        {{ userInitials }}
                                    </span>
                                    <div class="pp-user-text">
                                        <div kendoTooltip class="grid-tooltip" position="bottom">
                                            <h3 class="pp-name">{{ userName }}</h3>
                                        </div>
                                        <div class="pp-role">{{ userRoleName }}</div>
                                        <div class="pp-email" *ngIf="userEmail" [title]="userEmail">{{ userEmail }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Info Rows -->
                                <dl class="pp-info">
                                    <dt>PERMISSION LEVEL</dt>
                                    <dd>{{ userRoleName }}</dd>
                                    <dt>FACILITIES</dt>
                                    <dd>{{ facilitiesLabel }}</dd>
                                    <dt>LAST SIGN-IN</dt>
                                    <dd>{{ lastSignIn }}</dd>
                                </dl>

                                <!-- Change Status (existing) -->
                                <div class="pp-status" *ngIf="currentUserDomain != facilityDomainId" [hidden]="true">
                                    <div class="pp-label">STATUS</div>
                                    <div class="pp-status-options">
                                        <button type="button" class="pp-chip text-success"
                                            [class.active]="_coreHelper.selectedUserStatus === userStatus.Available"
                                            (click)="updateUserStatus(userStatus.Available)">
                                            <span class="bg-success dot-10"></span>Available
                                        </button>
                                        <button type="button" class="pp-chip text-warning"
                                            [class.active]="_coreHelper.selectedUserStatus === userStatus.Away"
                                            (click)="updateUserStatus(userStatus.Away)">
                                            <span class="bg-warning dot-10"></span>Away
                                        </button>
                                        <button type="button" class="pp-chip text-danger"
                                            [class.active]="_coreHelper.selectedUserStatus === userStatus.Busy"
                                            (click)="updateUserStatus(userStatus.Busy)">
                                            <span class="bg-danger dot-10"></span>Busy
                                        </button>
                                        <button type="button" class="pp-chip text-danger"
                                            *ngIf="_coreHelper.selectedUserStatus !== userStatus.Break && isVOBDepartment()"
                                            (click)="updateUserStatus(userStatus.Break)">
                                            <span class="bg-danger dot-10 minusSign">&#8211;</span>Take a break
                                        </button>
                                    </div>
                                </div>

                                <!-- Menu Links (existing) -->
                                <ul class="pp-menu">
                                    <li>
                                        <a href="javascript:;" [routerLink]="['auth/profile']"
                                            (click)="setPageTitle('Profile'); closeProfilePanel()">
                                            <span class="custom-icons icon-user"></span>Account settings
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" (click)="commingSoon(); closeProfilePanel()">
                                            <span class="custom-icons icon-help"></span>Get Help
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" (click)="commingSoon(); closeProfilePanel()">
                                            <span class="custom-icons icon-info"></span>About Cereus
                                        </a>
                                    </li>
                                </ul>

                                <!-- Viewing As (prototype only) -->
                                <div class="pp-viewas" *ngIf="showViewingAs" [hidden]="true">
                                    <div class="pp-viewas-title">VIEWING AS <em>prototype only</em></div>
                                    <div class="pp-field">
                                        <label for="ppViewRole">PERMISSION LEVEL</label>
                                        <select id="ppViewRole" class="form-select form-select-sm"
                                            [(ngModel)]="viewAsRoleId" (ngModelChange)="onViewAsChange()">
                                            <option *ngFor="let r of viewAsRoles" [ngValue]="r.id">{{ r.name }}</option>
                                        </select>
                                    </div>
                                    <div class="pp-field">
                                        <label for="ppViewUser">USER</label>
                                        <select id="ppViewUser" class="form-select form-select-sm"
                                            [(ngModel)]="viewAsUserId" (ngModelChange)="onViewAsChange()">
                                            <option *ngFor="let u of viewAsUsers" [ngValue]="u.id">{{ u.name }}</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- Sign out (existing) -->
                                <div class="pp-footer">
                                    <button type="button" class="pp-signout" (click)="closeProfilePanel(); logout()">
                                        Sign out
                                    </button>
                                </div>
                            </div>
                            <!-- Profile Popover end -->
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</header>

<!-- Logout Confirmation -->
<kendo-dialog title="Cereus Software" *ngIf="showLogoutConfirmationPopup" (close)="onLogoutClose()"
    class="kendo-modal modal-sm">
    <div class="common-popup-space text-center">
        <h5 class="mb-2">Are you sure want to Sign out ?</h5>
    </div>
    <kendo-dialog-actions class="d-block text-end">
        <button kendoButton (click)="onLogoutClose()" class="btn btn-cancel btn-md">Cancel</button>
        <button kendoButton (click)="logoutUser(true)" class="btn btn-primary btn-md">Sign out</button>
    </kendo-dialog-actions>
</kendo-dialog>
<!-- Logout Confirmation -->

<!-- On Notification Click -->
<app-cereus-dialog *ngIf="this.showSaveConfirmation" [showConfirmDialog]="true"
    [dialogBodyMessage]="'All changes will be lost if you leave?'" [yesButtonText]="'Leave'" [noButtonText]="'Stay'"
    (noButtonClickEvent)="onNoOptionSelected()" (yesButtonClickEvent)="onYesOptionsSelected()">
</app-cereus-dialog>